module.exports = __webpack_public_path__ + "fonts/OpenSans400.99fb07c3.woff";